module.exports = __webpack_public_path__ + "img/pmbg.18e621f7.png";